<template>
	<div>
		<ReportTitle
			:tripId="tripReport.tripReportId"
			:tripName="tripReport.name"
			:tripBeginDt="tripReport.beginDt"
			:tripEndDt="tripReport.endDt"
			:privacySetting="tripReport.privacy"
			:locale="locale"
		/>
		<!-- <div v-if="header" class="MyReportsReport MyReportsReport--header"></div>
		<div v-else class="MyReportsReport">
			<span class="MyReportsReport-species">
				<span class="Heading Heading--h3 Heading--reverse u-margin-none">{{ tripReport.numSpecies }}</span>
				<span class="u-text-1 u-uppercase u-stack-xs">Species</span>
			</span>
			<div class="MyReportsReport-title">
				<CloHeading level="3" classes="u-margin-none"
					><a :href="baseUrl + 'tripreport/' + tripReport.tripReportId">{{ tripReport.name }}</a></CloHeading
				>
			</div>
			<div class="MyReportsReport-timePeriod">
				<span class="Heading Heading--h5 Heading--sub u-margin-none">{{ tripReport.beginDt }} - {{ tripReport.endDt }}</span>
			</div>
		</div> -->
	</div>
</template>

<script>
import Vue from 'vue';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
import ReportTitle from './ReportTitle.vue';

export default Vue.extend({
	name: 'MyReportsReport',
	components: {
		CloHeading,
		CloIcon,
		ReportTitle,
	},
	props: {
		header: {
			type: Boolean,
			default: false,
		},
		tripReport: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			expanded: true,
			baseUrl: window.baseUrl,
		};
	},
});
</script>

<style lang="scss">
.MyReportsReport {
	background-color: $color-white;
	// @include text(3);
	// display: grid;
	// grid-template-columns: auto 1fr;
	// grid-template-rows: auto auto;
	// column-gap: $space-md;
	// grid-template-areas:
	// 	'species	title'
	// 	'species	timePeriod';
	// @include breakpoint(large) {
	// 	grid-template-columns: auto auto 1fr;
	// 	grid-template-rows: auto;
	// 	align-items: center;
	// 	grid-template-areas: 'species title timePeriod';
	// }
}
.MyReportsReport-species {
	grid-area: species;
	// grid-column: 1 / 2;
	// grid-row: 1 / -1;
	@include inset-squish-sm;
	border-radius: $radius-sm;
	color: $color-white;
	background-color: $color-primary-3;
	display: flex;
	flex-direction: column;
	align-items: center;
	align-self: start;
}
.MyReportsReport-title {
	grid-area: title;
	// grid-column: 2 / 3;
	// grid-row: 1 / 2;
}
.MyReportsReport-timePeriod {
	grid-area: timePeriod;
	// grid-column: 2 / 3;
	// grid-row: 2 / 3;
}
</style>
